import { render, staticRenderFns } from "./categoryDbhType.vue?vue&type=template&id=4344ae46&scoped=true&"
import script from "./categoryDbhType.vue?vue&type=script&lang=js&"
export * from "./categoryDbhType.vue?vue&type=script&lang=js&"
import style0 from "./categoryDbhType.vue?vue&type=style&index=0&id=4344ae46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4344ae46",
  null
  
)

export default component.exports